// tslint:disable

import { get } from 'lodash';
import * as React from 'react';
import { FormLib } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { IriPresenter } from '../structurals/presenters/iri-presenter';
import { DatepickerField } from './datepicker.field';
import { IriField } from './iri.field';

export class TimestampBlameable extends BaseField<any> {
    public form: FormLib = this.props.form;

    render () {
        return (<div>



            {this.form.fields.author &&
                <IriField
                    defaultAll={true}
                    field={this.form.fields.author}
                    forceQuery={{limit: 50, author: true}}
                    itemRender={(item: any) => {
                        return (
                            <div>
                                <IriPresenter iri={get(item, "person.@id")} render={(person: any) => {
                                    return (`${get(person, "firstName")} ${get(person, "surName")}`)
                                }}/>&nbsp;
                                (<IriPresenter iri={get(item, "company.@id")} render={(company: any) => get(company, 'name')}/> / <IriPresenter iri={get(item, "job.@id")} render={(job: any) => get(job, 'title')}/>)
                            </div>
                        )
                    }}
                />
            }

            <DatepickerField
                field={this.form.fields.publishedAt}/>

            <DatepickerField
                field={this.form.fields.deletedAt}/>

            <div className="divider"></div>

            <div className="form-group">
                <label htmlFor="">Created By</label>
                {this.form.fields.createdBy.value &&
                    <div className="form-control disabled"><IriPresenter iri={get(this.form.fields.createdBy.value, '@id')} render={(person: any) => `${get(person, 'firstName')} ${get(person, 'surName')}`}/></div>
                }
                {!this.form.fields.createdBy.value &&
                    <div className="form-control disabled">N/A</div>
                }
            </div>

            <DatepickerField
                disabled={true}
                field={this.form.fields.createdAt}/>

            <div className="divider"></div>

            <div className="form-group">
                <label htmlFor="">Updated By</label>
                {this.form.fields.updatedBy.value &&
                    <div className="form-control disabled"><IriPresenter iri={get(this.form.fields.updatedBy.value, '@id')} render={(person: any) => `${get(person, 'firstName')} ${get(person, 'surName')}`}/></div>
                }
                {!this.form.fields.updatedBy.value &&
                <div className="form-control disabled">N/A</div>
                }
            </div>

            <DatepickerField
                disabled={true}
                field={this.form.fields.updatedAt}/>

        </div>);
    }

}



// WEBPACK FOOTER //
// ./src/components/fields/TimestampBlameable.tsx